/*
 * Get-discounts.ts
 * Description: Includes the declaration
 * of the function for getting a list of all discounts in a town
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';
// Importing JSON:API normalization function
import normalize from 'normalize-json-api-response';
// Importing Vuex Store
import {store} from '@/config/plugins';

/**
 * Getting the list of discounts of a specific town
 *
 * @return {Object} Promise - a list of categories
 * @param {String} ekatte - id of a town
 */
export function getDiscounts(ekatte: string) {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'discounts',
            method: 'get',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            params: {
                town: ekatte,
            },
            data: {},
        }).then((response) => {
            resolve(normalize(response.data));
        }).catch(() => {
            reject();
        });
    });
}

/**
 * Getting the list of discounts of a specific restaurant
 *
 * @return {Object} Promise - a list of categories
 * @param {String} slug - slug of the restaurant
 */
export function getDiscountsRestaurant(slug: string) {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'restaurants/' + slug + '/discounts',
            method: 'get',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {},
        }).then((response) => {
            store.dispatch('setResponse', response.data.data);
            resolve();
        }).catch(() => {
            reject();
        });
    });
}

